import { useNavigate, useParams } from "react-router-dom";
import { ReceiptDetailPage } from "@/components/ReceiptDetailPage";

export function ReceiptPage() {
  const { receiptId } = useParams<{ receiptId: string }>();
  const navigate = useNavigate();

  if (!receiptId) return null;

  return (
    <ReceiptDetailPage
      receiptId={receiptId}
      onBack={() => navigate("/receipts")}
      onExpenseClick={(expenseId) => navigate(`/expenses/${expenseId}`)}
    />
  );
}
